<table class="table-borderless signatures">
  <tbody>
    <tr>
      <td style="width: 50%; padding: 0">
        <authority-labs-certificate-signature
          [user]="assignee"
          [date]="date"
        ></authority-labs-certificate-signature>
      </td>
      <td style="width: 50%; padding: 0">
        <authority-labs-certificate-signature
          *ngIf="approval && assignee.username !== approval.username"
          [user]="approval"
          [date]="date"
        ></authority-labs-certificate-signature>
      </td>
    </tr>
  </tbody>
</table>
